<template>
    <sections>
        <loading-widget v-if="activeStreams === null || upcomingStreams === null || dancers === null"></loading-widget>
        <div v-else>
            <section-home-jumbo :activeStreams="activeStreams" :upcomingStreams="upcomingStreams"></section-home-jumbo>
            <section-cookies></section-cookies>
            <section-text color="bg-zinc-50" heading="Search" content="<p>Videos, classes, events and dancers!</p>">
                <template v-slot:custom>
                    <div class="mt-6 mb-2">
                        <layout-search-bar-light
                            :searchQuery="searchQuery"
                            :makeSearch="makeSearchWithRedirect"
                            placeholder="Search west coast swing..."
                        ></layout-search-bar-light>
                    </div>
                </template>
            </section-text>
            <section-cards
                padding="pt-12 pb-16"
                heading="Featured Dancers"
                :cards="
                    dancers.map((dancer) => {
                        return {
                            route: dancer.dancer_route,
                            image: dancer.dancer_thumb_url,
                            heading: dancer.dancer_name,
                            excerpt:
                                '<p>' +
                                dancer.dancer_videos +
                                ' Video' +
                                (parseInt(dancer.dancer_videos) === 1 ? '' : 's') +
                                '</p>',
                        };
                    })
                "
            ></section-cards>
        </div>
    </sections>
</template>

<script setup>
const {activeStreams, upcomingStreams} = storeToRefs(useStoreStreams());

const {searchQuery} = storeToRefs(useStoreSearch());
const {makeSearch} = useStoreSearch();

const timeout = ref(null);

function makeSearchWithRedirect(input) {
    makeSearch(input);
    if (timeout.value) clearTimeout(timeout.value);
    timeout.value = setTimeout(() => {
        useRouter().push('/search');
    }, 500);
}

const {dancers} = storeToRefs(useStoreHome());
const {getHome} = useStoreHome();

await useLazyAsyncData('getHome', () => getHome().then(() => true));

onMounted(() => {
    makeSearch('');
});

const $config = useRuntimeConfig();
useSeo().buildHead({
    title: $config.public.siteName + ' | West Coast Swing',
    description: $config.public.siteStrapline,
    index: true,
});
</script>
